import { create } from 'zustand';
import { getActions } from './actions.js';
const DEFAULT_EX_WALLET_PROVIDER_STATE = {
    EvmProvider: undefined,
    evmContext: undefined,
    SolanaProvider: undefined,
    solanaContext: undefined,
    CosmosProvider: undefined,
    cosmosContext: undefined,
};
export const useExternalWalletProviderStore = create(set => (Object.assign(Object.assign({}, DEFAULT_EX_WALLET_PROVIDER_STATE), getActions(set))));
